// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pg-6";
export var imgContainer = "_pg-3";
export var menuIcon = "_pg-5";
export var pillWrapper = "_pg-2";
export var pillsContainer = "_pg-1";
export var subscriptionCard = "_pg-0";
export var subscriptionLogo = "_pg-4";